import PropTypes from "prop-types"
import React from "react"
import Switch from "react-switch"

import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"

//i18n
import { withTranslation } from "react-i18next"

import { faMoon, faSun } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import LanguageDropdown from "components/CommonForBoth/TopbarDropdown/LanguageDropdown"
import NotificationDropdown from "components/CommonForBoth/TopbarDropdown/NotificationDropdown"
import { layoutModeTypes, useLayoutStore } from "store/useLayoutStore"
import PingActivity from "components/CommonForBoth/TopbarDropdown/PingActivity"

const Header = props => {
  const setLayoutModeType = useLayoutStore(state => state.setLayoutModeType)
  const layoutModeType = useLayoutStore(state => state.layoutModeType)

  function tToggle() {
    var body = document.body
    if (window.screen.width <= 998) {
      body.classList.toggle("sidebar-enable")
    } else {
      body.classList.toggle("vertical-collapsed")
      body.classList.toggle("sidebar-enable")
    }
  }

  const Offsymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        <FontAwesomeIcon icon={faSun} />
      </div>
    )
  }

  const OnSymbol = () => {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          fontSize: 12,
          color: "#fff",
          paddingRight: 2,
        }}
      >
        <FontAwesomeIcon icon={faMoon} />
      </div>
    )
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header bg-primary">
          <div className="d-flex">
            <button
              type="button"
              onClick={() => {
                tToggle()
              }}
              className="btn btn-sm px-3 font-size-16 header-item "
              id="vertical-menu-btn"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
          </div>
          <div className="d-flex">
            <LanguageDropdown />
            <NotificationDropdown />
            <PingActivity />
            <ProfileMenu />
            <div
              className="dropdown d-inline-block"
              style={{ marginTop: "20px" }}
            >
              <Switch
                uncheckedIcon={<Offsymbol />}
                checkedIcon={<OnSymbol />}
                onColor="#2a3142"
                onChange={() => {
                  setLayoutModeType(
                    layoutModeType == layoutModeTypes.DARK
                      ? layoutModeTypes.LIGHT
                      : layoutModeTypes.DARK
                  )
                }}
                checked={layoutModeType == layoutModeTypes.DARK}
              />
            </div>
          </div>
        </div>
      </header>
    </React.Fragment>
  )
}

Header.propTypes = {
  t: PropTypes.any,
}

export default withTranslation()(Header)
